/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, shape, string } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import GridList from '@material-ui/core/GridList';
import ReactMarkdown from 'react-markdown';
import Media from 'react-media';
import PlantsButton from '../Buttons/PlantsButton';
import CategoryCarouselUI from './Partials/GraphqlHPCategoryCarouselUI';

const styles = (theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        overflow: 'hidden',
        textAlign: 'center',
        color: '#757575',
        fontSize: '14px',
        fontFamily: 'Roboto, Regular',
        backgroundColor: theme.palette.background.paper,
        clear: 'both',
        paddingTop: '15px',
    },
    plantsRoot: {
        minHeight: '316px',
        paddingTop: '1%',
        marginBottom: '1.5rem',
        fontFamily: 'Hind, sans-serif',
        fontSize: '14px',
        textAlign: 'center',
        '@media and screen (max-width)': {
            marginLeft: '0',
            marginRight: '0',
        },
    },
    plantsGridList: {
        flexWrap: 'nowrap',
        paddingLeft: '15px',
        marginTop: '1rem',
    },
    gridList: {
        flexWrap: 'nowrap',
        transform: 'translateZ(0)',
        width: '100%',
    },
    plantsTitle: {
        width: '100%',
        marginTop: '1rem',
        marginBottom: '1rem',
        paddingLeft: '15px',
        '& > *': {
            fontSize: 14,
            margin: '10px auto',
        },
        '& h3': {
            maxWidth: '200px',
            '& > *': {
                fontWeight: 900,
            },
        },
    },
    title: {
        width: '100%',
        color: theme.palette.common?.black,
        fontWeight: 600,
        '& > *': {
            fontSize: 14,
            margin: '10px auto',
        },
        '& h3': {
            maxWidth: '160px',
            '& > *': {
                fontWeight: 900,
            },
        },
    },
    tileIcon: {
        width: '75px',
        height: 'auto',
        clipPath: 'ellipse(36px 36px at 38px 41px)',
        webkitClipPath: 'ellipse(36px 36px at 38px 41px)',
    },
});

const GraphqlHPCategoryCarousel = ({
    classes, data, ssrDeviceType, presentationFamily, brand,
}) => (
    <Media
        query="(max-width: 767px)"
        defaultMatches={ssrDeviceType === 'mobile'}
        render={() => (
            <div className={brand?.code === 'PLA' ? classes.plantsRoot : classes.root}>
                <ReactMarkdown
                    source={data?.title}
                    skipHtml
                    className={brand?.code === 'PLA' ? classes.plantsTitle : classes.title}
                />
                <GridList className={brand?.code === 'PLA' ? classes.plantsGridList : classes.gridList} cols={2.5} cellHeight={110}>
                    {data?.carousel_group?.map((tileData) => (
                        <CategoryCarouselUI key={`${tileData?.link?.href}`} tileData={tileData} presentationFamily={presentationFamily} brand={brand} />
                    ))}
                </GridList>
                {brand?.code === 'PLA' ? <PlantsButton classes={classes} data={data} pageType="Category" /> : null}
            </div>
        )}
    />
);

GraphqlHPCategoryCarousel.propTypes = {
    data: object.isRequired,
    classes: object.isRequired,
    ssrDeviceType: string.isRequired,
    presentationFamily: string.isRequired,
    brand: shape({
        code: string,
    }).isRequired,
};

export default withStyles(styles)(GraphqlHPCategoryCarousel);
